import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import SignalR from '../../components/signalr';
import Loader from '../../components/snippets/loader';
import Button from '../../components/button';
import CallExtension from '../../components/callExtension';
import ReceptionistTabs from './partials/tabs';
import { SettingsContext } from '../../components/context';
import { getPrinterStatus, getPrinters, getCardReaders } from '../../models/setting';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactSVG from 'react-svg';
import iconTerminal from "./../../assets/images/icon-terminal.svg";
import iconDesktopPhone from "./../../assets/images/icon-desktop-phone.svg";
import i18n from '../../i18n';

class ReceptionistDevicesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      printers: null,
      recPrinters: null
    };

  }

  componentDidMount() {
    this.retrievePrinters();
    this.retrieveCardReaders();
  }

  retrievePrinters() {
    this.setState({isLoaded: false});
    getPrinterStatus()
      .then(
        result => {
          let printers = result;
          let isPrinterErrors = printers.filter(printer=>printer.status==='error'||printer.status==='warning').length>0;
          this.setState({
            printers,
            isPrinterErrors,
            isLoaded: true,
          });
        },
        error => {
          this.setState({
            isLoaded: false,
            error
          });
        }
      );
      getPrinters()
      .then(
        result => {
          let recPrinters = result.filter(printer => printer.printerType == 'reception');
          this.setState({
            recPrinters: recPrinters,
          });
        },
        error => {
          this.setState({
            error: error
          });
        }
      );
  }
  retrieveCardReaders = () => {
    getCardReaders()
      .then(
        result => {
          this.setState({
            cardReaders: result,
          });
        },
        error => {
          this.setState({
            error: error
          });
        }
      );
  }

  render() {
    const { t, siteSettings } = this.props;
    const { isLoaded, printers, error, recPrinters, cardReaders, isPrinterErrors } = this.state;
    const currentPageName = "Devices"
    return (
      <div className={'container-page lang-' + i18n.language}>
        <SignalR setReception={true} onPrinterTrouble={() => this.retrievePrinters()} />
        <div>
          <div className="container-body reception-background">
            <ReceptionistTabs page={currentPageName} siteSettings={siteSettings} isPrinterErrors={isPrinterErrors}/>
            <div className="reception-view">
              {error!==null?
                <Alert color="danger">{t(error)} <span className="alert-link mis-2" onClick={()=>window.location.reload()}>{t("Try again")}</span></Alert>
              :
                ( isLoaded ?
                  <div className="container">
                    <SettingsContext.Consumer>
                    {({settings, selPrinter, changePrinter, selCardReader, changeCardReader}) => (
                      <>
                      <div className="row mb-3">
                      {printers && printers.map((printer,i)=>{
                        return <div className="col-4 mb-2" key={i}>
                          <div className="card">
                            <div className="card-body text-center">
                              <FontAwesomeIcon icon="receipt" className={'h1 my-3 text-' + (printer.status==='ok'?'muted':'danger')} />
                              <h3>{t(printer.name)}</h3>
                            </div>
                            {recPrinters && recPrinters.some(pri => pri.id===printer.id)?
                            <div className="px-3 pb-3">
                              <div className="form-check">
                                <input type="checkbox" className="form-check-input" id={printer.id} checked={selPrinter == printer.id ?true:false} onChange={() => changePrinter(printer.id)}/> 
                                <label htmlFor={printer.id} className="form-check-label input-wrap pie-4 w-100">
                                  {t("Receptionist Printer")}
                                </label>
                              </div>
                            </div>
                            :null}
                            {printer.message?
                              <div className="card-footer">
                                <div>{t(printer.message)}</div>
                              </div>
                            :null}
                            {printer.status==='ok'?
                              <div className="card-footer text-success text-center">
                                <FontAwesomeIcon icon="check" /> {t("Connected")}
                              </div>
                            :null}
                          </div>
                        </div>
                      })}
                      </div>
                      <div className="row">
                      {cardReaders && cardReaders.map((cardReader,i)=>{
                        return <div className="col-4 mb-2" key={i}>
                          <div className="card h-100">
                            <div className="card-body text-center">
                              <ReactSVG src={iconTerminal} />
                              <h3>{t(cardReader.readerName)}</h3>
                            </div>
                            <div className="px-3 pb-3">
                              <div className="form-check">
                                <input type="checkbox" className="form-check-input" id={cardReader.stripeTerminalId} checked={selCardReader == cardReader.stripeTerminalId ?true:false} onChange={() => changeCardReader(cardReader.stripeTerminalId)}/> 
                                <label htmlFor={cardReader.stripeTerminalId} className="form-check-label input-wrap pie-4 w-100">
                                  {t("Selected Card Reader")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      })}
                      {settings && settings.pbxType && settings.pbxType.value?
                        <div className="col-4 mb-2">
                          <div className="card h-100">
                            <div className="card-body text-center">
                              <ReactSVG src={iconDesktopPhone} />
                              <h3>{t("Phone Extension")}</h3>
                            </div>
                            <div className="px-3 pb-3">
                              <CallExtension />
                            </div>
                          </div>
                        </div>
                      :null}
                      </div>
                      </>
                    )}
                    </SettingsContext.Consumer>
                  </div>
                : <Loader /> )
              }
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default withTranslation()(ReceptionistDevicesView);
